import apiClient from '@/lib/apiClient';
import { ApiResponse } from '@/types';

export interface RmPincodeEntry {
  userId: number;
  name: string;
  mobile: string;
  pincodes: string[];
}

export const rmPincodeService = {
  list: async (): Promise<RmPincodeEntry[]> => {
    const { data } = await apiClient.get<ApiResponse<RmPincodeEntry[]>>('/admin/rm-pincodes');
    return data.data ?? [];
  },

  replace: async (userId: number, pincodes: string[]): Promise<RmPincodeEntry> => {
    const { data } = await apiClient.put<ApiResponse<RmPincodeEntry>>(
      `/admin/rm-pincodes/${userId}`,
      { pincodes },
    );
    if (!data.data) throw new Error('Failed to update pincodes');
    return data.data;
  },
};
